import React from "react";
import LinkComp from "../LinkComp/LinkComp";
import { can } from "../../access";

// Top-level training courses, base → summit. The mountain.png art already
// contains the numbered tags (01–05); each title here is positioned next to its
// tag. `top`/`left` are % of the infographic — tweak to fine-tune alignment.
// Slugs match the routable chapters in TrainingSwitch.js.
const ITEMS = [
    {
        slug: 'tips-of-the-trade-and-inspiration',
        title: 'Tips of the Trade',
        desc: 'Practical advice and inspiration to sharpen your day-to-day.',
        color: '#E8472B',
        top: '34%', left: '41%',
    },
    {
        slug: 'administration',
        title: 'Administration',
        desc: 'Processes, paperwork, and the systems that keep us at the Summit',
        color: '#8A9199',
        top: '50%', left: '49%',
    },
    {
        slug: 'events',
        title: 'Events',
        desc: 'Company events, schedules, and how to get involved.',
        color: '#16B1C9',
        top: '63%', left: '52%',
    },
    {
        slug: 'roles-and-responsibilities',
        title: 'Roles & Responsibilities',
        desc: 'Who owns what across the team, and where you fit in.',
        color: '#7AB52B',
        top: '77%', left: '59%',
    },
    {
        slug: 'brokerage-continuum',
        title: 'Summit Brokerage Continuum',
        desc: 'The full brokerage journey, stage by stage to the summit.',
        color: '#F0A91E',
        top: '91%', left: '62%',
    },
];

export default class extends React.Component {
    constructor(props) {
        super(props);
        this.state = { heroLoaded: false };
        this.heroImgRef = React.createRef();
        this.handleHeroLoad = () => this.setState({ heroLoaded: true });
    }

    componentDidMount() {
        // A cached image can finish loading before React attaches onLoad, so sync here too.
        const img = this.heroImgRef.current;
        if (img && img.complete && img.naturalWidth > 0) {
            this.setState({ heroLoaded: true });
        }
    }

    render() {
        const base = arc.path.base;

        return (
            <div className='Training'>
                <div className='training-shell'>
                    <nav className='training-breadcrumb'>
                        <LinkComp to={base} className='training-breadcrumb__link'>Home</LinkComp>
                        <span className='training-breadcrumb__sep'>/</span>
                        <span className='training-breadcrumb__current'>Training</span>
                    </nav>

                    <div className='page-body-container'>
                        <div className='modules-section-heading'>
                            <div>
                                <div className='modules-section-title'>Climb the Summit</div>
                                <div className='modules-section-copy'>
                                    The SUMMIT is what drives us, but the climb itself is what matters.
                                </div>
                            </div>
                            <div className='modules-section-actions'>
                                {can('training.booklet') && (
                                    <LinkComp to={`${base}training-booklet`} className='button-new positive action'>
                                        Manage Booklet
                                    </LinkComp>
                                )}
                                <button className='button-new action' onClick={() => window.open(`${base}print-booklet/brokerage-continuum`, '_blank')}>
                                    Print Booklet
                                </button>
                            </div>
                        </div>

                        <div className='mountain-hero'>
                            {!this.state.heroLoaded && (
                                <div className='mountain-hero__placeholder' aria-hidden='true' />
                            )}
                            <img
                                ref={this.heroImgRef}
                                className={`mountain-hero__img${this.state.heroLoaded ? ' is-loaded' : ''}`}
                                src={base + 'img/mountain.png'}
                                alt='Summit training path'
                                width='988'
                                height='813'
                                onLoad={this.handleHeroLoad}
                            />
                            {ITEMS.map(item => (
                                <LinkComp
                                    key={item.slug}
                                    to={base + 'training/' + item.slug}
                                    className='mtn-label'
                                    style={{ '--accent': item.color, top: item.top, left: item.left }}
                                >
                                    <span className='mtn-label__title'>{item.title}</span>
                                    <span className='mtn-label__desc'>{item.desc}</span>
                                </LinkComp>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
